import React from 'react'
import { TabsView } from '../tabs-view'
import { AccordionView } from '../accordion-view'
import { VerticalTabsProps } from '../types'
import styles from './vertical-tabs.module.scss'

export const VerticalTabs: React.FC<VerticalTabsProps> = ({ items, colorStyle }) => {
  return (
    <>
      <TabsView items={items} className={styles.desktop} colorStyle={colorStyle} />
      <AccordionView items={items} className={styles.tablet} colorStyle={colorStyle} />
    </>
  )
}
